export default "/react/wbIcon-0085997f.svg";